application.register("lib-ajax", class extends Stimulus.Controller {
    link(e) {
        e.preventDefault();

        let element = e.currentTarget;

        // fetch(e.currentTarget.getAttribute("href")).then((response) => {
        //     return response.json();
        // }).then((payload) => {
        //     fn_ajaxHandler(payload);
        // })
        console.log(e, e.target.getAttribute("href"));

        importScript(cdnjs.jquery, () => {
            $.ajax({
                url: element.getAttribute("href"),
                data: {ajax: +new Date},
                dataType: "json",
            }).done(function (payload) {
                fn_ajaxHandler(payload);
            });
        })
    }

    linkComponent(e) {
        e.preventDefault();

        let element = e.currentTarget;
        let url = e.currentTarget.getAttribute('data-href');

        if (!url || !url.length) {
            url = e.currentTarget.getAttribute('href');
        }

        if (!url || !url.length) {
            console.log('no href attribute for ajax component link');
            return;
        }

        // fetch(url).then((response) => {
        //     return response.json();
        // }).then((payload) => {
        //     fn_ajaxHandler(payload, function () {
        //         if (typeof payload["dialog"] !== 'undefined' && payload["dialog"].length) {
        //             LibDialog.show(payload["dialog"]);
        //         }
        //     });
        // });

        importScript(cdnjs.jquery, () => {

            let data = {};

            let elm = $(element);
            if(elm.is('[data-change-input]')) {
                data[elm.attr('data-change-input')] = elm.val();
            }

            $.ajax({
                url: url,
                method: 'post',
                dataType: 'json',
                data: data
            }).done(function (payload) {
                fn_ajaxHandler(payload, function () {
                    if (typeof payload.dialog !== 'undefined' && payload.dialog.length) {
                        LibDialog.show(payload.dialog);
                    }
                });
            });
        })
    }

    form (e) {
        e.preventDefault();

        let frm = e.currentTarget,
            formData = new FormData(frm);

        if (typeof HTMLFormElement.prototype.reportValidity !== "undefined") {
            if (frm.reportValidity() === false) {
                return false;
            }

            [...frm.querySelectorAll(".part_ui_input")].map((element) => {
                application["getControllerForElementAndIdentifier"](element, "part_ui_input").validateInput(element, true)
            });

            [...frm.querySelectorAll(".part_ui_select:not(.state--active) select[required]")].map((element) => {
                element.parentNode.classList.add("state--invalid")
            });
        }

        if(frm.querySelector('button[type=submit]')) {
            frm.querySelector('button[type=submit]').classList.add('state--loading');
        }

        importScript(cdnjs.jquery, () => {

            if($('#snippet-basketDrop .elm_nav_basket_drop').hasClass('state--active')) {
                formData.append('basketDropActive','1');
            }

            $.ajax({
                method: frm.getAttribute('method'),
                url: frm.getAttribute('action'),
                data: formData,
                processData: false,
                contentType: false,
                dataType: "json",
            }).done(function (payload) {
                fn_ajaxHandler(payload, function () {
                    if (typeof payload.dialog !== 'undefined' && payload.dialog.length) {
                        LibDialog.show(payload.dialog);
                    }
                });
            }).always(function () {
                if(frm.querySelector('button[type=submit]')) {
                    frm.querySelector('button[type=submit]').classList.remove('state--loading');
                }
            });
        })
    }
});